import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SiteContentContext = createContext(null);

// Default content (fallback)
const defaultContent = {
  company_name: "ANZO",
  slogan: "barvanje & čiščenje",
  phone: "+386 40 848 406",
  email: "anzo.barvanje@gmail.com",
  notification_email: "anzo.barvanje@gmail.com",
  address: "Slovenija",
  facebook_url: "https://www.facebook.com/people/ANZO-Barvanje/61582719848195/",
  instagram_url: "",
  google_review_url: "",
  working_hours_weekdays: "PON-PET: 7.00-17.00",
  working_hours_weekend: "SOB-NED: Po dogovoru",
  working_hours_note: "(dosegljivi na telefon)",
  hero_title: "Dobrodošli v svet barv",
  hero_subtitle: "Pri nas je vedno barvito.",
  hero_description: "Smo podjetje, specializirano za barvanje in obnovo zunanjih površin...",
  hero_button_text: "Kontaktirajte Nas",
  hero_background_image: "https://customer-assets.emergentagent.com/job_anzo-fasade/artifacts/yu74l0mf_anzo6.jpg",
  logo_url: "https://customer-assets.emergentagent.com/job_anzo-fasade/artifacts/3mzdx3fu_anzo.jpg",
  services_title: "Naše Storitve",
  services_subtitle: "Profesionalno barvanje in zaščita vseh vrst površin.",
  services: [],
  gallery_title: "Naša Galerija",
  gallery_subtitle: "Oglejte si naše opravljeno delo.",
  gallery_images: [],
  why_title: "Zakaj Izbrati Nas?",
  why_items: [],
  about_title: "O Nas",
  about_text: "",
  about_image: "",
  about_features: [],
  contact_title: "Oddajte Povpraševanje",
  contact_subtitle: "Izpolnite obrazec in odgovorili vam bomo v najkrajšem možnem času.",
  service_types: [],
  footer_description: "Profesionalno barvanje in obnova zunanjih površin."
};

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(defaultContent);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchContent = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${BACKEND_URL}/api/content`);
      setContent(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching content:', err);
      setError(err.message);
      // Keep default content on error
    } finally {
      setLoading(false);
    }
  }, []);

  const updateContent = async (updates) => {
    try {
      await axios.patch(`${BACKEND_URL}/api/content`, updates);
      setContent(prev => ({ ...prev, ...updates }));
      return true;
    } catch (err) {
      console.error('Error updating content:', err);
      throw err;
    }
  };

  const saveFullContent = async (newContent) => {
    try {
      const response = await axios.post(`${BACKEND_URL}/api/content`, newContent);
      setContent(response.data);
      return true;
    } catch (err) {
      console.error('Error saving content:', err);
      throw err;
    }
  };

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return (
    <SiteContentContext.Provider value={{ 
      content, 
      loading, 
      error, 
      updateContent, 
      saveFullContent,
      refreshContent: fetchContent 
    }}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => {
  const context = useContext(SiteContentContext);
  if (!context) {
    throw new Error('useSiteContent must be used within a SiteContentProvider');
  }
  return context;
};

export default SiteContentContext;
